<template>
  <section class="company-data" aria-label="企业创新积分企业数据">
    <div class="query-bar">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="企业名称">
          <el-input v-model.trim="query.companyName" clearable placeholder="请输入企业名称" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="核算年度">
          <el-input v-model.trim="query.accountingYear" clearable maxlength="4" placeholder="请输入年度" />
        </el-form-item>
        <el-form-item label="企业阶段">
          <el-select v-model="query.enterpriseStage" clearable placeholder="全部阶段">
            <el-option v-for="stage in stages" :key="stage.value" :label="stage.label" :value="stage.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="toolbar-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增</el-button>
        <el-button icon="el-icon-download" :loading="downloading" @click="downloadTemplate">下载模板</el-button>
        <el-button icon="el-icon-upload2" @click="openImport">导入</el-button>
      </div>
    </div>

    <el-alert v-if="loadError" :title="loadError" type="error" show-icon :closable="false">
      <el-button slot="default" size="mini" @click="load">重新加载</el-button>
    </el-alert>

    <el-table v-else v-loading="loading" :data="rows" border stripe max-height="560" empty-text="暂无企业年度数据">
      <el-table-column label="基本信息" align="center">
        <el-table-column prop="companyName" label="企业名称" width="210" fixed="left" show-overflow-tooltip />
        <el-table-column prop="establishmentYears" label="成立年限(年)" width="110" fixed="left" align="center" />
        <el-table-column prop="enterpriseStageName" label="企业阶段" width="100" fixed="left" align="center" />
        <el-table-column prop="accountingYear" label="核算年度" width="100" fixed="left" align="center" />
        <el-table-column prop="contactName" label="联系人" width="110" fixed="left" show-overflow-tooltip />
        <el-table-column prop="contactPhone" label="联系电话" width="140" fixed="left" show-overflow-tooltip />
      </el-table-column>
      <el-table-column label="创新投入" align="center">
        <el-table-column prop="rdExpenseAmount" label="研发费用金额(元)" width="160" align="right" />
        <el-table-column prop="rdExpenseRevenueRatio" label="研发费用占营收比例(%)" width="190" align="right" />
        <el-table-column prop="rdPersonnelRatio" label="研发人员占比(%)" width="150" align="right" />
      </el-table-column>
      <el-table-column label="创新产出" align="center">
        <el-table-column prop="inventionPatentCount" label="发明专利授权量(件)" width="170" align="right" />
        <el-table-column prop="ipCountPerHundredRdPersonnel" label="每百人研发人员知识产权数量(件)" width="240" align="right" />
        <el-table-column prop="technologyContractAmount" label="技术合同成交额(元)" width="180" align="right" />
      </el-table-column>
      <el-table-column label="创新发展" align="center">
        <el-table-column prop="mainBusinessRevenue" label="主营业务收入(元)" width="170" align="right" />
        <el-table-column prop="revenueGrowthRate" label="营业收入增长率(%)" width="170" align="right" />
        <el-table-column prop="netAssetProfitRate" label="净资产利润率(%)" width="160" align="right" />
      </el-table-column>
      <el-table-column label="科技项目与奖励" align="center">
        <el-table-column prop="provincialProjectAwardCount" label="省级及以上符合项数" width="170" align="right" />
        <el-table-column prop="municipalProjectAwardCount" label="地市级符合项数" width="150" align="right" />
      </el-table-column>
      <el-table-column label="标准与融资" align="center">
        <el-table-column prop="standardParticipationCount" label="国家/行业标准符合项数" width="190" align="right" />
        <el-table-column prop="financingAmount" label="融资金额(万元)" width="150" align="right" />
      </el-table-column>
      <el-table-column label="榜单与资质" align="center">
        <el-table-column prop="internationalRankingCount" label="国际榜单符合项数" width="160" align="right" />
        <el-table-column prop="nationalRankingCount" label="国家榜单符合项数" width="160" align="right" />
        <el-table-column prop="provincialRankingCount" label="省级榜单符合项数" width="160" align="right" />
        <el-table-column prop="technologyQualificationCount" label="科技资质符合项数" width="160" align="right" />
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="230" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-data-analysis" @click="openScore(scope.row)">数据展示</el-button>
          <el-button type="text" icon="el-icon-edit" @click="openEdit(scope.row)">修改</el-button>
          <el-button type="text" class="danger-action" icon="el-icon-delete" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :current-page="query.page" :page-size="query.pageSize" :page-sizes="[10, 15, 30, 50]"
        @current-change="changePage" @size-change="changePageSize" />
    </div>

    <el-dialog :title="form.id ? '修改企业年度数据' : '新增企业年度数据'" :visible.sync="dialogVisible"
      width="1180px" top="5vh" append-to-body :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="260px" class="company-form">
        <div class="form-section">
          <h4>一、企业基本信息</h4>
          <div class="form-grid form-grid-basic">
            <el-form-item label="企业名称" prop="companyName"><el-input v-model.trim="form.companyName" maxlength="200" /></el-form-item>
            <el-form-item label="成立年限(年)" prop="establishmentYears"><el-input-number v-model="form.establishmentYears" :min="0" :precision="0" :step="1" @change="handleYearsChange" /></el-form-item>
            <el-form-item label="企业阶段" prop="enterpriseStage"><el-select v-model="form.enterpriseStage"><el-option v-for="stage in stages" :key="stage.value" :label="stage.label" :value="stage.value" /></el-select></el-form-item>
            <el-form-item label="核算年度" prop="accountingYear"><el-input-number v-model="form.accountingYear" :min="1900" :max="2100" :precision="0" :controls="false" /></el-form-item>
            <el-form-item label="联系人" prop="contactName"><el-input v-model.trim="form.contactName" maxlength="100" /></el-form-item>
            <el-form-item label="联系电话" prop="contactPhone"><el-input v-model.trim="form.contactPhone" maxlength="50" /></el-form-item>
          </div>
        </div>

        <div class="form-section">
          <h4>二、核心基础指标核算（满分100分）</h4>
          <table class="data-entry-table" aria-label="核心指标实际数据">
            <thead>
              <tr>
                <th scope="col">一级指标</th>
                <th scope="col">二级指标</th>
                <th scope="col">实际数据</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="group in coreGroups">
                <tr v-for="(field, fieldIndex) in group.fields" :key="field.prop">
                  <td v-if="fieldIndex === 0" :rowspan="group.fields.length" class="group-cell">{{ group.label }}</td>
                  <td class="item-cell">{{ field.label }}</td>
                  <td class="value-cell">
                    <el-form-item :prop="field.prop" label-width="0">
                      <div class="number-with-unit">
                        <el-input-number v-model="form[field.prop]" :min="0" :precision="field.precision"
                          :step="field.step" :controls="false" />
                        <span class="input-unit">{{ field.unit }}</span>
                      </div>
                    </el-form-item>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="form-section">
          <h4>三、创新影响加分项核算（单项封顶10分，合计满分30分）</h4>
          <table class="data-entry-table" aria-label="加分数据">
            <thead>
              <tr>
                <th scope="col">加分维度</th>
                <th scope="col">评分项</th>
                <th scope="col">符合条件项数/金额</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="group in bonusGroups">
                <tr v-for="(field, fieldIndex) in group.fields" :key="field.prop">
                  <td v-if="fieldIndex === 0" :rowspan="group.fields.length" class="group-cell">{{ group.label }}</td>
                  <td class="item-cell">{{ field.label }}</td>
                  <td class="value-cell">
                    <el-form-item :prop="field.prop" label-width="0">
                      <div class="number-with-unit">
                        <el-input-number v-model="form[field.prop]" :min="0" :precision="field.precision"
                          :step="1" :controls="false" />
                        <span class="input-unit">{{ field.unit }}</span>
                      </div>
                    </el-form-item>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入企业年度数据" :visible.sync="importVisible" width="720px" append-to-body
      :close-on-click-modal="false" @closed="clearImport">
      <el-upload ref="upload" drag action="" :auto-upload="false" :limit="1" accept=".xlsx" :on-change="selectImportFile" :on-remove="removeImportFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将 .xlsx 文件拖到此处，或<em>点击选择</em></div>
        <div slot="tip" class="el-upload__tip">请使用本页面下载的模板。任一行校验失败时整批不会写入。</div>
      </el-upload>
      <div v-if="importResult" class="import-result">
        <el-alert v-if="!importResult.errors.length" type="success" show-icon :closable="false"
          :title="`导入成功：共${importResult.totalRows}条，新增${importResult.createdCount}条，更新${importResult.updatedCount}条`" />
        <template v-else>
          <el-alert type="error" show-icon :closable="false" :title="`发现${importResult.errors.length}个错误，整批未写入`" />
          <el-table :data="importResult.errors" border max-height="260" size="small">
            <el-table-column prop="rowNumber" label="行号" width="80" align="center" />
            <el-table-column prop="field" label="字段" width="210" />
            <el-table-column prop="reason" label="原因" min-width="260" />
          </el-table>
        </template>
      </div>
      <span slot="footer">
        <el-button @click="importVisible = false">关闭</el-button>
        <el-button type="primary" :loading="importing" :disabled="!importFile" @click="submitImport">开始导入</el-button>
      </span>
    </el-dialog>
    <enterprise-innovation-score-detail v-model="scoreVisible" :company-data-id="scoreCompanyDataId"
      @closed="scoreCompanyDataId = null" />
  </section>
</template>

<script>
import { saveAs } from 'file-saver';
import EnterpriseInnovationScoreDetail from './EnterpriseInnovationScoreDetail.vue';

const API = 'apij2/admin-api/trade/enterprise-innovation-company-data';
const STAGES = [
  { value: 'STARTUP', label: '初创期' },
  { value: 'GROWTH', label: '成长期' },
  { value: 'STABLE', label: '稳定期' }
];
const CORE_FIELDS = [
  { prop: 'rdExpenseAmount', label: '研发费用金额', unit: '元', precision: 2, step: 1000 },
  { prop: 'rdExpenseRevenueRatio', label: '研发费用占营业收入比例', unit: '%', precision: 2, step: 0.1 },
  { prop: 'rdPersonnelRatio', label: '研发人员占比', unit: '%', precision: 2, step: 0.1 },
  { prop: 'inventionPatentCount', label: '发明专利授权量', unit: '件', precision: 2, step: 1 },
  { prop: 'ipCountPerHundredRdPersonnel', label: '每百人研发人员的知识产权数量', unit: '件', precision: 2, step: 1 },
  { prop: 'technologyContractAmount', label: '企业技术合同成交额', unit: '元', precision: 2, step: 1000 },
  { prop: 'mainBusinessRevenue', label: '主营业务收入', unit: '元', precision: 2, step: 1000 },
  { prop: 'revenueGrowthRate', label: '营业收入增长率', unit: '%', precision: 2, step: 0.1 },
  { prop: 'netAssetProfitRate', label: '净资产利润率', unit: '%', precision: 2, step: 0.1 }
];
const BONUS_FIELDS = [
  { prop: 'provincialProjectAwardCount', label: '省级及以上科技项目/奖励', unit: '项', precision: 0 },
  { prop: 'municipalProjectAwardCount', label: '地市级科技项目/奖励', unit: '项', precision: 0 },
  { prop: 'standardParticipationCount', label: '参与制定国家/行业标准', unit: '项', precision: 0 },
  { prop: 'financingAmount', label: '融资金额', unit: '万元', precision: 2 },
  { prop: 'internationalRankingCount', label: '国际榜单符合条件项数', unit: '项', precision: 0 },
  { prop: 'nationalRankingCount', label: '国家榜单符合条件项数', unit: '项', precision: 0 },
  { prop: 'provincialRankingCount', label: '省级榜单符合条件项数', unit: '项', precision: 0 },
  { prop: 'technologyQualificationCount', label: '科技资质符合条件项数', unit: '项', precision: 0 }
];
const CORE_GROUPS = [
  { label: '创新投入(50%)', fields: CORE_FIELDS.slice(0, 3) },
  { label: '创新产出(30%)', fields: CORE_FIELDS.slice(3, 6) },
  { label: '创新发展(20%)', fields: CORE_FIELDS.slice(6, 9) }
];
const BONUS_GROUPS = [
  { label: '科技项目与标准制定', fields: BONUS_FIELDS.slice(0, 3) },
  { label: '融资额度', fields: BONUS_FIELDS.slice(3, 4) },
  { label: '行业排名与科技资质', fields: BONUS_FIELDS.slice(4, 8) }
];

function emptyForm() {
  const form = { id: null, companyName: '', establishmentYears: null, enterpriseStage: '', accountingYear: new Date().getFullYear(), contactName: '', contactPhone: '' };
  CORE_FIELDS.forEach(field => { form[field.prop] = null; });
  BONUS_FIELDS.forEach(field => { form[field.prop] = field.precision === 0 ? 0 : null; });
  return form;
}

export default {
  name: 'CompanyDataConfig',
  components: { EnterpriseInnovationScoreDetail },
  data() {
    const requiredNumber = label => ({ required: true, message: `请输入${label}`, trigger: 'change' });
    const rules = {
      companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
      establishmentYears: [requiredNumber('成立年限')], enterpriseStage: [requiredNumber('企业阶段')],
      accountingYear: [requiredNumber('核算年度')]
    };
    [...CORE_FIELDS, ...BONUS_FIELDS].forEach(field => { rules[field.prop] = [requiredNumber(field.label)]; });
    return {
      stages: STAGES, coreGroups: CORE_GROUPS, bonusGroups: BONUS_GROUPS, rules,
      query: { companyName: '', accountingYear: '', enterpriseStage: '', page: 1, pageSize: 15 },
      rows: [], total: 0, loading: false, loadError: '', dialogVisible: false, saving: false,
      form: emptyForm(), formOriginal: '', importVisible: false, importFile: null, importing: false,
      importResult: null, downloading: false, scoreVisible: false, scoreCompanyDataId: null
    };
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.loading = true; this.loadError = '';
      try {
        const params = Object.keys(this.query).filter(key => this.query[key] !== '' && this.query[key] !== null)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`).join('&');
        const res = await this.http.get(`${this.urlConfig.devUrl}${API}/page?${params}`, true);
        this.rows = (res.data && res.data.data) || [];
        this.total = Number((res.data && res.data.total) || 0);
      } catch (error) {
        this.loadError = (error && (error.msg || error.status)) || '企业年度数据加载失败';
      } finally { this.loading = false; }
    },
    search() { this.query.page = 1; this.load(); },
    resetQuery() { this.query = { companyName: '', accountingYear: '', enterpriseStage: '', page: 1, pageSize: this.query.pageSize }; this.load(); },
    changePage(page) { this.query.page = page; this.load(); },
    changePageSize(size) { this.query.pageSize = size; this.query.page = 1; this.load(); },
    openCreate() { this.form = emptyForm(); this.formOriginal = JSON.stringify(this.form); this.dialogVisible = true; },
    openScore(row) { this.scoreCompanyDataId = Number(row.id); this.scoreVisible = true; },
    async openEdit(row) {
      try {
        const res = await this.http.get(`${this.urlConfig.devUrl}${API}/get?id=${row.id}`, true);
        this.form = { ...emptyForm(), ...(res.data || {}) };
        this.formOriginal = JSON.stringify(this.form);
        this.dialogVisible = true;
      } catch (error) { /* global interceptor displays the error */ }
    },
    handleYearsChange(value) {
      if (value === null || value === undefined || value < 0) { this.form.enterpriseStage = ''; return; }
      this.form.enterpriseStage = value <= 5 ? 'STARTUP' : value <= 10 ? 'GROWTH' : 'STABLE';
    },
    submit() {
      this.$refs.dataForm.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.form.id) await this.http.put(`${this.urlConfig.devUrl}${API}/update`, this.form, true);
          else await this.http.post(`${this.urlConfig.devUrl}${API}/create`, this.form, true);
          this.formOriginal = JSON.stringify(this.form);
          this.$message.success('企业年度数据已保存');
          this.dialogVisible = false;
          this.load();
        } finally { this.saving = false; }
      });
    },
    remove(row) {
      this.$confirm(`确定删除“${row.companyName}”${row.accountingYear}年度的数据吗？`, '删除确认', { type: 'warning' })
        .then(async () => {
          await this.http.delete(`${this.urlConfig.devUrl}${API}/delete?id=${row.id}`, '', true);
          this.$message.success('已删除');
          if (this.rows.length === 1 && this.query.page > 1) this.query.page -= 1;
          this.load();
        }).catch(() => {});
    },
    resetForm() { if (this.$refs.dataForm) this.$refs.dataForm.clearValidate(); this.form = emptyForm(); this.formOriginal = ''; },
    hasChanges() { return this.dialogVisible && Boolean(this.formOriginal) && JSON.stringify(this.form) !== this.formOriginal; },
    openImport() { this.importVisible = true; },
    selectImportFile(file) { this.importFile = file.raw; this.importResult = null; },
    removeImportFile() { this.importFile = null; this.importResult = null; },
    clearImport() { this.importFile = null; this.importResult = null; if (this.$refs.upload) this.$refs.upload.clearFiles(); },
    authHeaders() {
      try {
        const raw = this.$store.state.userInfo;
        const user = raw ? JSON.parse(raw) : null;
        return user && user.token ? { Authorization: user.token } : {};
      } catch (error) { return {}; }
    },
    async submitImport() {
      if (!this.importFile) return;
      this.importing = true;
      try {
        const formData = new FormData(); formData.append('file', this.importFile);
        const response = await this.http.axios.post(`${this.urlConfig.devUrl}${API}/import`, formData, { headers: this.authHeaders() });
        if (Number(response.data.code) !== 0) throw new Error(response.data.msg || response.data.status || '导入失败');
        this.importResult = response.data.data;
        if (!this.importResult.errors.length) { this.$message.success('导入成功'); this.load(); }
      } catch (error) {
        this.$message.error(error.message || (error.response && error.response.data && error.response.data.msg) || '导入失败');
      } finally { this.importing = false; }
    },
    async downloadTemplate() {
      this.downloading = true;
      try {
        const response = await this.http.axios.get(`${this.urlConfig.devUrl}${API}/import-template`, { responseType: 'blob', headers: this.authHeaders() });
        const contentType = response.headers && response.headers['content-type'];
        if (!contentType || !contentType.includes('spreadsheetml')) throw new Error('模板响应格式不正确');
        saveAs(response.data, '企业创新积分企业数据导入模板.xlsx');
      } catch (error) { this.$message.error('模板下载失败'); }
      finally { this.downloading = false; }
    }
  }
};
</script>

<style lang="scss" scoped>
.query-bar { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; margin-bottom: 14px; }
.query-bar ::v-deep .el-form-item { margin-bottom: 8px; }
.query-bar ::v-deep .el-input { width: 190px; }
.toolbar-actions { display: flex; flex-shrink: 0; }
.pagination-wrap { display: flex; justify-content: flex-end; padding-top: 16px; }
.danger-action { color: #f56c6c; }
.company-form { max-height: 70vh; overflow-y: auto; padding-right: 12px; }
.form-section { padding: 0 0 4px; border-bottom: 1px solid #ebeef5; margin-bottom: 18px; }
.form-section:last-child { border-bottom: 0; margin-bottom: 0; }
.form-section h4 { margin: 0 0 16px; color: #303133; font-size: 15px; line-height: 22px; text-align: left; }
.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 20px; }
.form-grid-basic { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.form-grid-basic ::v-deep .el-form-item__label { width: 110px !important; }
.form-grid-basic ::v-deep .el-form-item__content { margin-left: 110px !important; }
.company-form ::v-deep .el-input-number, .company-form ::v-deep .el-select, .company-form ::v-deep .el-input { width: 100%; }
.company-form ::v-deep .el-input-number .el-input__inner { text-align: right; }
.data-entry-table { width: 100%; border-collapse: collapse; table-layout: fixed; color: #303133; font-size: 14px; }
.data-entry-table th { height: 42px; padding: 0 12px; border: 1px solid #dcdfe6; background: #0878bd; color: #fff; font-weight: 600; text-align: center; }
.data-entry-table th:nth-child(1) { width: 29%; }
.data-entry-table th:nth-child(2) { width: 43%; }
.data-entry-table th:nth-child(3) { width: 28%; }
.data-entry-table td { height: 46px; padding: 4px 12px; border: 1px solid #dcdfe6; background: #fff; vertical-align: middle; }
.data-entry-table .group-cell { background: #fafafa; font-weight: 500; text-align: center; }
.data-entry-table .item-cell { line-height: 20px; }
.data-entry-table .value-cell { padding: 4px 10px; }
.data-entry-table .value-cell ::v-deep .el-form-item { margin-bottom: 0; }
.data-entry-table .value-cell ::v-deep .el-form-item__content { margin-left: 0 !important; }
.number-with-unit { display: flex; align-items: center; gap: 8px; }
.data-entry-table .value-cell ::v-deep .el-input-number { width: calc(100% - 32px); }
.input-unit { width: 24px; flex: 0 0 24px; color: #606266; text-align: left; }
.data-entry-table .value-cell ::v-deep .el-input__inner { height: 34px; line-height: 34px; }
.import-result { margin-top: 18px; }
.import-result .el-table { margin-top: 12px; }
::v-deep .el-upload, ::v-deep .el-upload-dragger { width: 100%; }
::v-deep .el-alert { margin-bottom: 14px; }
@media (max-width: 1280px) {
  .query-bar { display: block; }
  .toolbar-actions { margin-top: 4px; }
  .form-grid-basic { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
